module.exports = __webpack_public_path__ + "media/images/pic/courses/3-a91e2827718f242f0e45ff58f6141ec7.jpeg";